// extracted by mini-css-extract-plugin
export default {"container":"Map_container__t7cUc","map":"Map_map__5zO03","dragbox":"Map_dragbox__DJecP"};